// removed by extract-text-webpack-plugin
module.exports = {"cont":"ScrollArrow__cont___8pmCm","arrow":"ScrollArrow__arrow___2sJFZ"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/ScrollArrow/ScrollArrow.css
// module id = 752
// module chunks = 0